'use client'

import { DownloadSimpleIcon, LinkSimpleIcon } from '@phosphor-icons/react'
import { Ring2 } from 'ldrs/react'
import { useTranslations } from 'next-intl'

import { useVideoDownload } from '@/hooks/utils'

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem
} from '../ui/dropdown-menu'

import { Copy } from './copy'

export type ShareMenuProps = {
  link: string
  videoUrl?: string
  children: React.ReactNode
}
export const ShareMenu = ({ link, videoUrl, children }: ShareMenuProps) => {
  const t = useTranslations()

  const [isDownloading, downloadVideo] = useVideoDownload()

  const handleDownload = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    downloadVideo(videoUrl)
  }

  const fullLink = typeof window !== 'undefined' ? `${window.location.origin}${link}` : link

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="z-popover flex flex-col gap-0.5 rounded-md p-1.5"
        side="top"
      >
        <DropdownMenuItem asChild>
          <Copy asChild text={fullLink} type="link">
            <button className="flex size-full h-10 cursor-pointer items-center gap-1.5 hover:bg-light/12">
              <LinkSimpleIcon className="size-5" color="white" weight="bold" />
              <span className="text-sm font-medium">{t('work.copyLink')}</span>
            </button>
          </Copy>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <button
            className="flex size-full h-10 cursor-pointer items-center gap-1.5 hover:bg-light/12"
            disabled={isDownloading}
            onClick={handleDownload}
          >
            {isDownloading ? (
              <Ring2 color="white" size={20} stroke={2} />
            ) : (
              <DownloadSimpleIcon className="size-5" color="white" weight="bold" />
            )}
            <span className="text-sm font-medium">{t('common.download')}</span>
          </button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
